export default __webpack_public_path__ + "static/media/PNG transparent file 03@2x.3ef462cc.png";